import React from 'react';
import axios from "../../../../containers/api";
import {Button, CardBody, Row, CardTitle} from "reactstrap";
import {Colxx, Separator} from "../../../../components/common/CustomBootstrap";
import {Table} from "../../../../components/table/Table";
import {showCatchError} from "../../../../helpers/Utils";

class ShowLoadHallUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            OneLoadHall: this.props.OneLoadHall,
            LoadHalls: this.props.LoadHalls,
            LoadHallsUsers: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({
                OneLoadHall: this.props.OneLoadHall,
                LoadHalls: this.props.LoadHalls
            });
        }
    }

    componentDidMount() {
        this.GetByUserId();
    }

    GetByUserId = () => {
        this.props.showSpinner();
        axios.get('/api/v1/load-hall-users/GetByUserId?Id=' + this.state.OneLoadHall.userId)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ LoadHallsUsers: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };

    DeleteLoadHallUser = (Id) => {
        this.props.showSpinner();
        let model = {
            Item1: Id
        };
        axios.post('/api/v1/load-hall-users/DeleteLoadHallUser', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.GetByUserId()
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    AddLoadHallUser = (LoadHallId) => {
        let model = {
            LoadHallId: LoadHallId,
            UserAdminId: this.state.OneLoadHall.userId
        }

        this.props.showSpinner();
        axios.post('/api/v1/load-hall-users/AddLoadHallUser', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.GetByUserId();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody>
                        <CardTitle>
                            لیست سالن های
                            {" "}
                            {this.state.OneLoadHall && this.state.OneLoadHall.fullName}
                        </CardTitle>

                        <Table
                            tableHeaders={[
                                "شناسه",
                                "نام کامل", 
                                "تلفن",
                                "حذف",
                            ]}

                            tableRow={this.state.LoadHallsUsers !== null ? this.state.LoadHallsUsers : []}

                            tableData={[
                                LoadHall => {
                                    return "LoadHall" + LoadHall.loadHallId;
                                },
                                LoadHall => {
                                    return LoadHall.name;
                                },
                                LoadHall => {
                                    return LoadHall.tel;
                                },
                                
                                LoadHall => {
                                    return (
                                        <Button outline color="danger" size="sm"
                                            onClick={() => this.DeleteLoadHallUser(LoadHall.id)}>
                                            حذف
                                        </Button>
                                    )
                                }
                            ]}
                        />

                        <Separator className="my-5" />

                        <CardTitle>لیست کل سالن‌ها</CardTitle>

                        <Table
                            tableHeaders={[
                                "شناسه",
                                "نام کامل",
                                "تلفن",
                                "افزودن",
                            ]}

                            tableRow={this.state.LoadHalls !== null ? this.state.LoadHalls : []}

                            tableData={[
                                LoadHall => {
                                    return "LoadHall" + LoadHall.loadHallId;
                                },
                                LoadHall => {
                                    return LoadHall.name;
                                },
                                LoadHall => {
                                    return LoadHall.tel;
                                }, 
                                LoadHall => {
                                    return (
                                        <Button outline color="success" size="sm"
                                            onClick={() => this.AddLoadHallUser(LoadHall.loadHallId)}>
                                            افزودن
                                        </Button>
                                    )
                                }
                            ]}
                        />
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default ShowLoadHallUser;